import {useState, useEffect} from "react";
import {useHistory} from "react-router-dom";
import NavBar from "../../../utils/nav/NavBar";
import NavMenu from "../../../utils/nav/NavMenu";
import Loading from "../../../utils/loading";
import Authorization from "../../../utils/secure/Authorization";
import Search from "../../../utils/search";
import Checkbox from "../../../utils/checkBox";
import PillOptions from "../../../utils/pillOptions";
import ScrollToTopButton from "../../../utils/scrollToTopButton";
import PullToRefresh from "react-simple-pull-to-refresh";
import ButtonAdd from "../../../utils/buttonAdd";
import { GetPurchaseSuggested, PostOrdenCompra, DeleteOrdenCompra } from "../../../../services/purchaseServices";
import PurchaseSuggestedAdd from "./purchase-suggested-add";

import "../../../../css/purchase-receipt.css";

const PurchaseSuggested = () => {
    const history = useHistory();
    const [permissionChecked, setPermissionChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState(history.location.state?.searchText || "");
    const [filtroProveedor, setFiltroProveedor] = useState(history.location.state?.filtroProveedor || "Todos");
    const [soloConFaltante, setSoloConFaltante] = useState(history.location.state?.soloConFaltante !== undefined ? history.location.state.soloConFaltante : true);
    const [sugeridos, setSugeridos] = useState([]);
    const [showAdd, setShowAdd] = useState(false);

    const getScrollContainer = () => document.querySelector('.ptr__children');

    const handleCancelarOrdenes = async () => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const formatDate = (d) => d.toISOString().slice(0, 10);
        const todayStr = formatDate(today);
        const tomorrowStr = formatDate(tomorrow);

        const fechaSeleccionada = window.prompt(
            `¿Fecha de las órdenes a cancelar?\n` +
            `Ingresa:\n  1 → Hoy (${todayStr})\n  2 → Mañana (${tomorrowStr})`
        );
        if (fechaSeleccionada === null) return;

        let fecha;
        if (fechaSeleccionada.trim() === "1") {
            fecha = todayStr;
        } else if (fechaSeleccionada.trim() === "2") {
            fecha = tomorrowStr;
        } else {
            alert("Opción inválida. Ingresa 1 para hoy o 2 para mañana.");
            return;
        }

        if (!window.confirm(`¿Cancelar órdenes de compra del ${fecha}?`)) return;
        try {
            setLoading(true);
            await DeleteOrdenCompra(fecha);
            alert("Ordenes de compra canceladas");
            await cargar();
        } catch (error) {
            console.error("Error al cancelar órdenes de compra", error);
            alert("Error al cancelar las órdenes de compra");
        } finally {
            setLoading(false);
        }
    };

    const handleGenerarOrdenes = async () => {
        if (!window.confirm("¿Generar órdenes de compra?")) return;
        try {
            setLoading(true);
            await PostOrdenCompra();
            alert("Ordenes de compra generadas");
            await cargar();
        } catch (error) {
            console.error("Error al generar órdenes de compra", error);
            alert("Error al generar las órdenes de compra");
        } finally {
            setLoading(false);
        }
    };

    const handleNavigateToDetail = (id) => {
        const scrollContainer = getScrollContainer();
        history.push({
            pathname: `/purchase-suggested/${id}`,
            state: {
                searchText: searchText,
                filtroProveedor: filtroProveedor,
                soloConFaltante: soloConFaltante,
                scrollY: scrollContainer ? scrollContainer.scrollTop : 0
            }
        });
    };

    useEffect(() => {
        cargar();
    }, []);

    useEffect(() => {
        const savedScrollY = history.location.state?.scrollY;
        if (!savedScrollY || sugeridos.length === 0 || loading) return;

        let attempts = 0;
        const tryScroll = () => {
            const container = getScrollContainer();
            if (!container) return;
            if (container.scrollHeight >= savedScrollY + container.clientHeight || attempts >= 30) {
                container.scrollTop = savedScrollY;
            } else {
                attempts++;
                requestAnimationFrame(tryScroll);
            }
        };
        requestAnimationFrame(tryScroll);
    }, [sugeridos, loading]);

    const cargar = async () => {
        try {
            setLoading(true);
            const data = await GetPurchaseSuggested();
            setSugeridos(data);
        } catch (error) {
            console.error("Error al cargar sugeridos", error);
        } finally {
            setLoading(false);
        }
    };

    const filterItems = () => {
        let rValue = sugeridos;

        if (filtroProveedor !== "Todos") {
            rValue = rValue.filter(p => p.proveedor === filtroProveedor);
        }

        if (soloConFaltante) {
            rValue = rValue.filter(p => p.faltante > 0);
        }

        if (searchText !== "") {
            rValue = rValue.filter(
                (p) =>
                    p.descripcion.toLowerCase().includes(searchText) ||
                    p.proveedor.toLowerCase().includes(searchText)
            );
        }

        return rValue;
    };

    const proveedores = ["Todos", ...new Set(sugeridos.map(item => item.proveedor))];

    return (
        <div id="purchase-suggested">
            {!permissionChecked && (
                <Authorization
                    permission="Compras/SugeridoCompras"
                    onPermissionGranted={() => setPermissionChecked(true)}
                />
            )}
            <ScrollToTopButton/>
            <PullToRefresh onRefresh={cargar}>
                <div className="page-header">
                    <NavBar
                        title="Sugerido de compras"
                        navButtonComponent={<NavMenu/>}
                        toolbar={
                            <>
                                <button className="round-button shadow" style={{backgroundColor: 'var(--danger)'}} onClick={handleCancelarOrdenes}>
                                    <i className="fas fa-times"></i>
                                </button>
                                <button className="round-button shadow secondary" onClick={handleGenerarOrdenes}>
                                    <i className="fas fa-play"></i>
                                </button>
                                <ButtonAdd onClick={() => setShowAdd(true)} />
                            </>
                        }
                    />
                    <div className="bar single suggested--suppliers-bar">
                        <PillOptions
                            options={proveedores}
                            variant="primary suggested--suppliers-pills"
                            selected={filtroProveedor}
                            onSelect={(option) => setFiltroProveedor(option)}
                        />
                    </div>
                </div>

                <div className="page-content">
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem'}}>
                        <div style={{flex: 1}}>
                            <Search
                                initialSearchText={searchText}
                                onSearch={(searchText) => setSearchText(searchText.toLowerCase())}
                            />
                        </div>
                        <div style={{marginBottom: '1rem'}}>
                            <Checkbox 
                                label="Solo con faltante"
                                checked={soloConFaltante}
                                onCheckedChanged={() => setSoloConFaltante(!soloConFaltante)}
                            />
                        </div>
                    </div>

                    <div className="page-list">
                        {filterItems().map((item) => (
                            <div key={item.id} className="purchaseReceipt--item list-item">
                                <div className="col1" onClick={() => handleNavigateToDetail(item.id)}>
                                    <img className="thumbnail" src={item.imageUrl} alt=""/>
                                </div>
                                <div className="col2 suggested--item-info" onClick={() => handleNavigateToDetail(item.id)}>
                                    <div className="suggested--item-supplier" >{item.proveedor}</div>
                                    <div className="suggested--item-description">{item.descripcion}</div>
                                    
                                    <div className="suggested--item-grid">
                                        <div className="suggested--label">Pedidos:</div>
                                        <div className="suggested--value">{item.pedidos} {item.unidad}</div>
                                        
                                        <div className="suggested--label">Existencia:</div>
                                        <div className="suggested--value">{item.existencia} {item.unidad}</div>
                                        
                                        <div className="suggested--label">Faltante:</div>
                                        <div className="suggested--value">{item.faltante} {item.unidad}</div>
                                        
                                        <div className="suggested--label">Sugerido:</div>
                                        <div className="suggested--value" style={item.sugerido === 0 ? {color: "#787272"} : {}}>{item.sugerido} {item.unidad}</div>

                                        <div className="suggested--label">Solicitar:</div>
                                        <div className="suggested--value" style={item.cantidadSolicitada !== item.sugerido ? {color: "#cfa913"} : {}}>{item.cantidadSolicitada} {item.unidad}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </PullToRefresh>
            {loading && <Loading/>}
            {showAdd && (
                <PurchaseSuggestedAdd 
                    existingProductIds={sugeridos.map(s => s.idProducto || s.id)}
                    onProductSelected={(productId) => handleNavigateToDetail(productId)}
                    onClose={() => setShowAdd(false)}
                />
            )}
        </div>
    );
};

export default PurchaseSuggested;
